import { GenericDialogPanelProps } from "./GenericDialogPanel";
import { dialogStyles } from "./dialogStyles";

// Helper function for string capitalization
const formatProductName = (productName?: string) => {
  if (!productName || !productName.trim()) return "This product";
  const trimmed = productName.trim().toLowerCase();
  return `${trimmed.charAt(0).toUpperCase()}${trimmed.slice(1)}`;
};

type DialogConfigProps = Omit<GenericDialogPanelProps, "open" | "onCancel" | "onConfirm">;

export const dialogConfigs = {
  productNotAvailable: (productName?: string): DialogConfigProps => ({
    styleProfile: dialogStyles.bottomSheetWarning, 
    title: "Product Not Available",
    alertTitle: `${formatProductName(productName)} is not added to this origin`,
    alertSubtitle: "Would you like to add this product to this origin?",
    cancelLabel: "Cancel",
    confirmLabel: "Add Product",
  }),

  deleteConfirmation: (itemName: string): DialogConfigProps => ({
    styleProfile: dialogStyles.centerModalError,
    title: "Delete Item",
    severity: "error",
    alertTitle: `Are you sure you want to delete ${itemName}?`,
    alertSubtitle: "This action cannot be undone.",
    cancelLabel: "Cancel",
    confirmLabel: "Delete",
  }),
};